export const FETCH_VINCHECK_REQUEST = 'FETCH_VINCHECK_REQUEST';
export const FETCH_VINCHECK_SUCCESS = 'FETCH_VINCHECK_SUCCESS';
export const FETCH_VINCHECK_FAILURE = 'FETCH_VINCHECK_FAILURE';
export const RESET_STATE = 'RESET_STATE';
